import { createStore } from 'vuex';
// ストアの作成
export default createStore({
    state: {
        isAuthenticated: false
    },
    mutations: {
        setAuthentication(state, status) {
            state.isAuthenticated = status;
        }
    },
    actions: {
        authenticate({ commit }, status) {
            commit('setAuthentication', status);
        }
    },
    getters: {
        isAuthenticated: state => state.isAuthenticated
    }
});
// // import { createStore } from '../vuex';
// // export const store = createStore({
// //     state: {
// //         isAuthenticated: false
// //     },
// //     mutations: {
// //         setAuthentication(state, status) {
// //             state.isAuthenticated = status;
// //             //alert(status);
// //         }
// //     },
// //     actions: {
// //         authenticate({ commit }, status) {
// //         commit('setAuthentication', status);
// //         }
// //     },
// //     getters: {
// //       isAuthenticated: state => state.isAuthenticated
// //     }
// // });
//export default store;
